"use client";
import React, { useEffect, useState } from "react";
import TestimonialsImg1 from '../../assets/images/testimonial/testimonial-one-client-1-1.jpg'
import TestimonialsImg2 from '../../assets/images/testimonial/testimonial-one-client-1-2.jpg'
import TestimonialsImg3 from '../../assets/images/testimonial/testimonial-one-client-1-3.jpg'
import TestimonialsImg4 from '../../assets/images/testimonial/testimonial-one-client-1-4.jpg'
import TestimonialsImg5 from '../../assets/images/testimonial/testimonial-one-client-1-5.jpg'
import TestimonialsImg6 from '../../assets/images/testimonial/testimonial-one-client-1-6.jpg'
import { getTestimonials } from "../../services/settingsService";
import imgPlaceholder from '../../assets/images/resources/img-placeholder.svg';
import { TESTIMONIAL_IMAGE_POOL, pickPoolImage } from '../../utils/imagePools';

const fallbackTestimonials = [
  { clientName: "Rahim Uddin", role: "Attendee", clientImage: TestimonialsImg1, text: "Events are special occasions where people gather together to celebrate, commemorate, or participate in a specific purpose or theme.", rating: 4 },
  { clientName: "Sumaiya Islam", role: "Organizer", clientImage: TestimonialsImg2, text: "Events are special occasions where people gather together to celebrate, commemorate, or participate in a specific purpose or theme.", rating: 4 },
  { clientName: "Jahid Hasan", role: "Attendee", clientImage: TestimonialsImg3, text: "Events are special occasions where people gather together to celebrate, commemorate, or participate in a specific purpose or theme.", rating: 4 },
  { clientName: "Mitu Akter", role: "Vendor", clientImage: TestimonialsImg4, text: "Events are special occasions where people gather together to celebrate, commemorate, or participate in a specific purpose or theme.", rating: 4 },
  { clientName: "Arif Chowdhury", role: "Attendee", clientImage: TestimonialsImg5, text: "Events are special occasions where people gather together to celebrate, commemorate, or participate in a specific purpose or theme.", rating: 4 },
  { clientName: "Nadia Sultana", role: "Organizer", clientImage: TestimonialsImg6, text: "Events are special occasions where people gather together to celebrate, commemorate, or participate in a specific purpose or theme.", rating: 4 },
];

export default function Home() {
  const [testimonials, setTestimonials] = useState(fallbackTestimonials);

  useEffect(() => {
    getTestimonials()
      .then((data) => {
        if (data.items && data.items.length > 0) {
          setTestimonials(data.items.map((t) => ({
            clientName: t.name, role: t.designation, clientImage: t.image, text: t.quote, rating: t.rating,
          })));
        }
      })
      .catch(() => {});
  }, []);

  return (

        <div>
          {/*Testimonials Page Start*/}
          <section className="testimonial-page">
            <div className="container">
              <div className="row">
                {testimonials.map((testimonial, index) => (
                  <div key={index} className="col-xl-6 col-lg-6 col-md-6">
                    <div className="testimonial-one__single">
                      <div className="testimonial-one__client-info-and-review">
                        <div className="testimonial-one__client-info">
                          <div className="testimonial-one__client-img">
                            <img
                              src={testimonial.clientImage || pickPoolImage(TESTIMONIAL_IMAGE_POOL, testimonial.clientName ?? index) || imgPlaceholder}
                              alt={testimonial.clientName}
                              onError={(e) => { e.target.onerror = null; e.target.src = imgPlaceholder; }}
                            />
                          </div>
                          <div className="testimonial-one__client-content">
                            <h4 className="testimonial-one__client-name">
                              {testimonial.clientName}
                            </h4>
                            <p className="testimonial-one__sub-title">
                              {testimonial.role}
                            </p>
                          </div>
                        </div>
                        <div className="testimonial-one__review">
                          {Array.from(
                            { length: testimonial.rating },
                            (_, i) => (
                              <span key={i} className="icon-star"></span>
                            )
                          )}
                          {Array.from(
                            { length: 5 - testimonial.rating },
                            (_, i) => (
                              <span
                                key={i + testimonial.rating}
                                className="icon-star clr-start"
                              ></span>
                            )
                          )}
                        </div>
                      </div>
                      <p className="testimonial-one__text">
                        {testimonial.text}
                      </p>
                      <div className="testimonial-one__quote">
                        <span className="icon-quote"></span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
          {/*Testimonials Page End*/}

        </div>
  );
}
